import request from '@/utils/request'

/* ══════════════════════════════════════════════
 *  消息通知 API
 * ══════════════════════════════════════════════ */

/**
 * 分页查询消息列表
 * @param {Object} params - { msgCategory, readStatus, page, pageSize }
 */
export function getMessagePage(params) {
  return request({ url: '/messages', method: 'get', params })
}

/**
 * 获取未读消息数量（按分类）
 */
export function getUnreadCount() {
  return request({ url: '/messages/unread-count', method: 'get' })
}

/**
 * 获取最近 N 条未读消息（铃铛下拉用）
 */
export function getRecentUnread(limit = 5) {
  return request({ url: '/messages/recent-unread', method: 'get', params: { limit } })
}

/**
 * 标记消息已读（单条）
 */
export function markAsRead(id) {
  return request({ url: `/messages/${id}/read`, method: 'post' })
}

/**
 * 批量标记已读
 */
export function markBatchRead(ids) {
  return request({ url: '/messages/batch-read', method: 'post', data: { ids } })
}

/**
 * 全部标记已读
 */
export function markAllRead(msgCategory) {
  return request({ url: '/messages/read-all', method: 'post', data: { msgCategory } })
}

/* ══════════════════════════════════════════════
 *  通知设置（消息通知配置）API
 * ══════════════════════════════════════════════ */

/**
 * 查询配置列表（含接收人）
 * @param {string} [msgCategory] - 分类筛选，不传或 'all' 返回全部
 */
export function getConfigList(msgCategory) {
  return request({ url: '/message-configs', method: 'get', params: { msgCategory } })
}

/**
 * 保存配置接收人
 * @param {string} configId - 配置场景 ID
 * @param {Array} recipients - [{ recipientId, recipientName }]
 */
export function saveConfigRecipients(configId, recipients) {
  return request({ url: `/message-configs/${configId}/recipients`, method: 'post', data: { recipients } })
}

/**
 * 切换配置启用/禁用状态
 * @param {string} configId - 配置场景 ID
 * @param {string} status - 'enabled' | 'disabled'
 */
export function toggleConfigStatus(configId, status) {
  return request({ url: `/message-configs/${configId}/status`, method: 'post', data: { status } })
}
